/** @jsxRuntime classic */
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Colors } from '@zapier/design-system';

import { COLOR_KEYS, MEDIA_MIN_WIDTH } from '../../../constants';
import { RichTextHTMLString } from '../types';

import { SubNav } from './SubNav';
import { Provider } from './Context';
import { ScrollableSections } from './ScrollableSections';
import { StickySections } from './StickySections';
import { AnimationSection, BackgroundColor } from './types';

type Props = {
  backgroundColor: BackgroundColor;
  title: RichTextHTMLString;
  sections: AnimationSection[];
};

const Styles = labelStyles('AnimationsSection', {
  root: (backgroundColor: BackgroundColor) =>
    css({
      width: '100%',
      backgroundColor: Colors[backgroundColor],
    }),
  container: css({
    maxWidth: '1170px',
    margin: 'auto',
    padding: '0 20px',
  }),
  section: css({
    display: 'flex',
    flexDirection: 'column',
    [MEDIA_MIN_WIDTH.small]: {
      justifyContent: 'space-between',
      flexDirection: 'row',
    },
  }),
});

function AnimationsSectionUnwrapped({
  backgroundColor = COLOR_KEYS.cream,
  sections,
  title,
}: Props) {
  return (
    <div css={Styles.root(backgroundColor)}>
      <div css={Styles.container}>
        <SubNav
          backgroundColor={backgroundColor}
          links={sections.map(({ navLinkText }) => ({ text: navLinkText }))}
          title={title}
        />
        <section css={Styles.section}>
          <ScrollableSections sections={sections} />
          <StickySections sections={sections} />
        </section>
      </div>
    </div>
  );
}

export const AnimationsSection = (props: Props) => (
  <Provider>
    <AnimationsSectionUnwrapped {...props} />
  </Provider>
);
